export enum FileUploadStatus {
  Loading = 'loading', // onBefore判断
  Pending = 'pending', // 上传中
  Success = 'success', // 上传成功
  Error = 'error', // 上传失败
  Transcoding = 'transcoding', // 转码中
  ReviewError = 'review_error', // 审核不通过
}

export type ValidateFields =
  | 'accept'
  | 'resolution'
  | 'size'
  | 'duration'
  | 'unity'
  | 'validator';

export interface ErrorInfo {
  type: ValidateFields | string | null;
  message?: string;
  status?: FileUploadStatus.Error | FileUploadStatus.ReviewError;
}

export interface RejectError {
  rule: BatchUploadRules;
  info: ErrorInfo;
}

export interface FileInfo {
  id: string;
  name: string;
  file: File | null;
  progress: number;
  status: FileUploadStatus;
  url: string;
  previewUrl: string; // 封面地址
  voiceUrl?: string; // 音频地址
  from: string;
  duration: number; // 时长（秒）
  resolution: string;
  errorInfo?: ErrorInfo;
  originFileObj?: File;
}

interface RuleCommon {
  message?: string; // 错误提示
}

export interface AcceptRule extends RuleCommon {
  accept: string[]; // 文件类型
}

export type Resolution = '480p' | '720p' | '1080p' | '2k' | '4k' | `${number}*${number}`;

export type FileSize = `${number}KB` | `${number}MB` | `${number}GB` | number;

export interface ResolutionRule extends RuleCommon {
  resolution: Resolution; // 分辨率 (宽*高 例如 1920*1080)
}

export interface UnityRule extends RuleCommon {
  unity: boolean; // 是否统一分辨率
}

export interface SizeRule extends RuleCommon {
  size: FileSize; // 文件大小 (不带单位默认为MB)
  target?: 'video' | 'audio' | 'image'; // 校验目标，不传默认全部
}

export interface DurationRule extends RuleCommon {
  duration: number; // 时长 (秒)
  target?: 'video' | 'audio'; // 校验目标，不传默认全部
  clip?: (value: FileInfo) => void;
}

export interface MaxRule extends RuleCommon {
  max: number; // 最大文件数量
}
export interface ImageMaxSize extends RuleCommon {
  size: number;
  target: string;
}

export interface CustomRule extends RuleCommon {
  validateType: string;
  validator: (value: FileInfo) => boolean | Promise<boolean>;
  target?: 'video' | 'audio' | 'image'; // 校验目标，不传默认全部
  render?: (value: FileInfo) => React.ReactNode;
}

export type BatchUploadRules =
  | AcceptRule
  | ResolutionRule
  | UnityRule
  | SizeRule
  | DurationRule
  | MaxRule
  | ImageMaxSize
  | CustomRule;

export enum UploadErrorCode {
  CANCEL = 'cancel',
  NETWORK_ERROR = 'network_error',
  MEDIA_ERR_ABORTED = 'media_err_abort', // '播放被用户中止'
  MEDIA_ERR_NETWORK = 'media_err_network', // '网络错误导致视频下载失败'
  MEDIA_ERR_DECODE = 'media_err_decode', // '视频解码失败，可能是格式或编码器不兼容'
  MEDIA_ERR_SRC_NOT_SUPPORTED = 'media_err_src_not_supported', // '视频格式或MIME类型不受支持'
}
